import React from 'react'
import { graphql, Link } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/layout';

export default ({ data }) => {
  const group = data.groupsYaml;
  const giins = data.allGiinsYaml ? data.allGiinsYaml.edges.map(({node}) => { return node; }) : [];
  const representative = giins ? giins.find(({identifier}) => identifier === group.representative) : null;

  return (
    <Layout>
      <SEO title={group.name}/>
      <p>> <Link to={'/groups'}>一覧</Link> > {group.name}</p>
      <h2>{group.name}</h2>
      <div>
        <table>
          <tbody>
            <tr>
              <th>代表</th><td>{representative ? <Link to={`/giins/${group.representative}`}>{representative.name}</Link> : null}</td>
            </tr>
            <tr>
              <th>構成議員</th>
              <td>
                <ul>
                  {
                    giins.map((giin) => <li><Link to={`/giins/${giin.identifier}`}>{giin.name}</Link></li>)
                  }
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Layout>
  )
};

export const query = graphql`
  query($identifier: String!) {
    groupsYaml(identifier: { eq: $identifier }) {
      identifier
      name
      representative
    }
    allGiinsYaml(filter: {fields: {currentGroup: {eq: $identifier}}}) {
      edges {
        node {
          name
          identifier
        }
      }
    }
  }
`;